import { createAsyncThunk } from "@reduxjs/toolkit";
import apiCall from "../AuthorizedApi";

export interface PlanExpiryAlertData {
    show_alert: boolean;
    plan_detail_id?: number | null;
    plan_name?: string | null;
    plan_type?: string | null;
    expiry_date?: string | null;
    days_left?: number | null;
    stage?: number | null;
    severity?: "info" | "warning" | "critical" | string;
    message?: string | null;
    dismissed?: boolean;
}

export const subscriptionsPlansAPI = createAsyncThunk(
    'subscription/subscriptionsPlansAPI',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiCall({
                method: 'GET',
                url: '/plans/all-plans/'
            });
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data);
        }
    }
);

export const getPlanExpiryAlertAPI = async (): Promise<PlanExpiryAlertData> => {
    const response = await apiCall({
        method: 'GET',
        url: '/plans/expiry-alert/'
    });
    return response.data;
};

export const dismissPlanExpiryAlertAPI = async (stage?: number | null): Promise<PlanExpiryAlertData> => {
    const response = await apiCall({
        method: 'POST',
        url: '/plans/expiry-alert/dismiss/',
        data: stage !== undefined && stage !== null ? { stage } : {}
    });
    return response.data;
};